var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/app/search/directives/search-result-event/search-result-event.html',
    '<div class="event-item">\n' +
    '    <div class="event-item-left-block" ng-if="item.background_image.thumb_path" style="background-image: url(\'{{ item.background_image.thumb_path }}\')">\n' +
    '    </div>\n' +
    '    <div class="event-item-right-block">\n' +
    '        <div class="event-item-date" ng-if="item.all_year_round">Круглогодично</div>\n' +
    '        <div class="event-item-date" ng-if="!item.all_year_round">{{ item.date_from | date:\'dd.MM.yyyy\' }} - {{ item.date_to | date:\'dd.MM.yyyy\' }}</div>\n' +
    '        <div class="event-item-name">\n' +
    '            <a href="{{ item.route_info }}" target="_blank" ng-bind-html="item.highlighted_title | rawHtml"></a>\n' +
    '        </div>\n' +
    '        <div class="event-item-content" ng-bind-html="item.highlighted_text | rawHtml"></div>\n' +
    '        <div class="event-item-location">\n' +
    '            Место проведения: {{ item.location }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

module.exports = "/app/search/directives/search-result-event/search-result-event.html";